import { render, staticRenderFns } from "./UdateApplicantPersonal.vue?vue&type=template&id=2c312dde&scoped=true&"
import script from "./UdateApplicantPersonal.vue?vue&type=script&lang=js&"
export * from "./UdateApplicantPersonal.vue?vue&type=script&lang=js&"
import style0 from "./UdateApplicantPersonal.vue?vue&type=style&index=0&id=2c312dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c312dde",
  null
  
)

export default component.exports